import { useContext } from "react";
import { useGameLoadable } from "../../helpers/use-game-loadable";
import { SessionService, SessionServiceContext } from "../../services/session";
import { useActiveDivision } from "../../services";

/**
 * This hook returns a function that will clear the active game
 * from the session service when called. Use this when done
 * playing a game
 */
export function useSessionState(gameId?: string) {
  const sessionService: SessionService | null = useContext(
    SessionServiceContext
  );

  const division = useActiveDivision();
  const gameInfo = useGameLoadable(gameId);

  const exit = () => {
    sessionService?.clearActiveSession();
  };

  const restart = async () => {
    const result = await gameInfo.ensuredValue();

    if (!sessionService) return;
    if (!result) throw new Error("Can't find game information.");

    if (sessionService.activeSession) {
      sessionService.clearGameSessionDataForGame(
        sessionService.activeSession.id
      );
    }
    const query = new URLSearchParams(window.location.search);

    const variables: { [key: string]: string } = {};

    query.forEach((value, key) => {
      if (key.startsWith("@")) {
        variables[key] = value;
      }
    });

    await sessionService.startNewSession(result, {
      source: { type: "restart" },
      divisionId: division?.id,
      variables,
    });
  };

  return {
    gameInfo,
    restart,
    exit,
    activeSession: sessionService?.activeSession,
  };
}
